/*------------------------add handle letters-------------------------*/
import {
  AddHandleLetterOld
} from './add-handle-letters-old';

/*------------------------list handle letters-------------------------*/
import {
  HandleLettersOld
} from './list-handle-letters-old';
/*-----------------------detail handle letters------------------------*/
import {
  HandleLettersOldDetails
} from './detail-handle-letters-old';

export {
  AddHandleLetterOld,
  HandleLettersOld,
  HandleLettersOldDetails
};



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/index.js